import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M306-250v-466q0-18 12-29t27-11l11 1q6 1 11 5l367 234q9 6 13 14 5 9 5 19t-5 19q-4 8-13 14L367-216q-5 4-11 5l-11 1q-15 0-27-11-12-10-12-29Zm79-233Zm0 161 254-161-254-161v322Z"/>',
  f: '<path d="M306-250v-466q0-18 12-29t27-11l11 1q5 1 11 5l367 234q9 6 13 14 5 9 5 19t-5 19q-4 8-13 14L367-216q-6 4-11 5l-11 1q-15 0-27-11-12-10-12-29Z"/>',
};

export default data;
